<template>
  <h1>Asignar Rol Usuario</h1>
</template>
<script>
export default {};
</script>
